// extracted by mini-css-extract-plugin
export default {"wrapper":"Books_wrapper__sIorx"};